import { render, staticRenderFns } from "./LancarNotaAnosanteriores.vue?vue&type=template&id=94dd45c0&scoped=true&"
import script from "./LancarNotaAnosanteriores.vue?vue&type=script&lang=js&"
export * from "./LancarNotaAnosanteriores.vue?vue&type=script&lang=js&"
import style0 from "./LancarNotaAnosanteriores.vue?vue&type=style&index=0&id=94dd45c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94dd45c0",
  null
  
)

export default component.exports